import {
	Fragment,
	memo,
} from 'react'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import { twMerge } from 'tailwind-merge'

const URLCheckRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/

const Text = ({ text }) => {
	if (URLCheckRegex.test(text)) {
		return <a className="underline" href={addHttpsProtocol(text)} target="_blank" rel="noreferrer">{text}</a>
	}
	return text
}

const LabelLink = ({ linkUrl, linkText, className }) => (
	<p>
		<a target="_blank" className={twMerge('underline hover:brightness-75', className)} href={linkUrl} rel="noreferrer">
			{linkText}
		</a>
	</p>
)

export default memo(({ text = '' }) => {
	const textParts = Array.isArray(text) ? text : text.split(/\n/)

	return (
		<>
			{textParts.map((textPart) => {
				const isLink = typeof textPart === 'object' && 'linkUrl' in textPart && 'linkText' in textPart
				if (isLink) {
					return (
						<LabelLink
							key={textPart.linkUrl + textPart.linkText}
							className={textPart.className}
							linkText={textPart.linkText}
							linkUrl={textPart.linkUrl}
						/>
					)
				}

				return (
					<Fragment key={textPart.toString()}>
						{textPart.split(/ /)
							.map((word, idx) => (
								// eslint-disable-next-line react/no-array-index-key
								<Fragment key={`${word}${idx}`}>
									<Text text={word} />{' '}
								</Fragment>
							))}
						{'\n'}
					</Fragment>
				)
			})}
		</>
	)
})
